/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { entity } from '../common/entity';
import { contact } from '../common/contact';
import { address } from '../common/address';
import { identification } from '../common/identification';
import { connectionparameters } from '../messages/connectionparameters';
import { transtypereference } from '../messages/transtypereference';
import { transtype } from './transtype';
import { basecode } from '../ehr/subs/basecode';

export class pharmacy extends IceEntity {
  trans_account: string = "";
  entity_key: string = "";
  address_key: string = "";
  taxonomy_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  ENTS: entity[] = [];
  CONS: contact[] = [];
  ADS: address[] = [];
  IDS: identification[] = [];
  CONNPARAMS: connectionparameters[] = [];
  TYPEREFS: transtypereference[] = [];
  INCONNPARAMS: connectionparameters[] = [];
  SVCTYPES: basecode[] = [];
  SVCLEVELS: number[] = [];
  TYPES: transtype[] = [];
  COUNTRIES: basecode[] = [];
  CURRENCIES: basecode[] = [];

  constructor() {
      super();
  }

  getdisplayname(): string {
    var ent = this.getsubtreedata("ENTS", "entity_key", this.entity_key);
    if (ent == null) return "";

    return ent.organization_name;
  }

  gettablename(): string {
      return "PHARMACY";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CONS") return true;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;
    else if (ColumnName == "IDS") return true;
    else if (ColumnName == "SVCTYPES") return true;
    else if (ColumnName == "SVCLEVELS") return true;
    else if (ColumnName == "TYPES") return true;
    else if (ColumnName == "CONNPARAMS") return true;
    else if (ColumnName == "TYPEREFS") return true;
    else if (ColumnName == "INCONNPARAMS") return true;
    else if (ColumnName == "COUNTRIES") return true;
    else if (ColumnName == "CURRENCIES") return true;

      return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CONS") return "CONTACT";
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";
    else if (ColumnName == "IDS") return "IDENTIFICATION";
    else if (ColumnName == "SVCTYPES") return "SERVICE_TYPE_CODE";
    else if (ColumnName == "SVCLEVELS") return "SERVICE_LEVEL";
    else if (ColumnName == "TYPES") return "TRANS_TYPE";
    else if (ColumnName == "CONNPARAMS") return "CONNECTION_PARAMETERS";
    else if (ColumnName == "TYPEREFS") return "TRANS_TYPE_REFERENCE";
    else if (ColumnName == "INCONNPARAMS") return "CONNECTION_PARAMETERS";
    else if (ColumnName == "COUNTRIES") return "COUNTRY";
    else if (ColumnName == "CURRENCIES") return "CURRENCY";

    return null;
  }
}

